import Cookies from 'universal-cookie'
import utils from '@/utils'
const cookies = new Cookies()
var cookieConfig = {}
var isIP = utils.isIP(window.location.hostname);
if (!isIP) { // 域名/localhost的情况需要设置cookie的domain属性
  if (window.location.hostname == 'localhost') {
    cookieConfig = {}
  } else {
    cookieConfig = {
      domain: '.byl.sh.cn'
    } // path:'/',maxAge:365*24*60*60 */
  }
}

export function saveCookie (name, value) {
  cookies.set(name, value, cookieConfig)
}

export function getCookie (name) {
  return cookies.get(name)
}

export function removeCookie (name) {
  cookies.remove(name, cookieConfig)
}



// WEBPACK FOOTER //
// ./src/store/cookies.js